const getters = {
  allEmployees: (state) => state.employeeList.data,
  allEmployeesPending: (state) => state.employeeList.status.pending,
};

export default getters;
